import VueI18n from 'vue-i18n';
import Vue from 'vue';
import en from './en.json';

Vue.use(VueI18n);

const messages = {
  en,
};

export default new VueI18n({
  locale: 'en',
  messages,
});



// WEBPACK FOOTER //
// ./src/i18n/index.js